import { render, staticRenderFns } from "./firstEncounterMain.vue?vue&type=template&id=45404d4f"
import script from "./firstEncounterMain.vue?vue&type=script&lang=js"
export * from "./firstEncounterMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports